import { render, staticRenderFns } from "./RegistrationGuide.vue?vue&type=template&id=2ec5d8d6"
import script from "./RegistrationGuide.vue?vue&type=script&lang=js"
export * from "./RegistrationGuide.vue?vue&type=script&lang=js"
import style0 from "./RegistrationGuide.vue?vue&type=style&index=0&id=2ec5d8d6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports